<template>
  <div class="navi-list-bg">
    <div style="margin: 5px 20px; display: flex; justify-content: space-between" v-if="!isFirst">
      <span>{{$t('edit.guide.gap.label')+listData.move_time+$t('edit.guide.gap.unitSecond')}}{{listData.music_url ? ','+$t('edit.guide.gap.audio') : ''}}{{listData.content ?',T':''}}</span>
      <div style="cursor:pointer;" @click="toSetting">{{$t('edit.setting')}}</div>
    </div>
    <div
      :class="{selected: selected.point_id === listData.point_id}"
      class="content"
      @click="onSelect"
    >
      <div><input type="checkbox" @change="handleChange" v-if="inputShow" :checked="listData.isChecked"/></div>
      <div class="type">{{index}}</div>
      <span class="content-name">{{listData.title}}</span>

      <a-dropdown>
        <a-menu slot="overlay" @click="handleMenuClick">
          <a-menu-item key="1">{{$t('actionTitles.rename')}}</a-menu-item>
          <a-menu-item key="2">{{$t('actionTitles.delete')}}</a-menu-item>
        </a-menu>
        <a-button>
          {{$t('edit.options')}}
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    inputShow:Boolean,
    index: {
      required: true,
      type: Number,
    },
    isFirst: {
      required: true,
      type: Boolean,
    },
    listData: {
      type: Object,
      required: true,
    },
    selected: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selectedId: "",
    };
  },
  methods: {
    toSetting() {
      this.$emit("toSettingPoint", this.listData);
    },
    handleMenuClick({ item, key }) {
      console.log(item);
      if (key === "1") {
        this.$emit("renameItem", this.listData);
      } else if (key === "2") {
        this.$emit("deleteItem", this.listData);
      }
    },
    onSelect() {
      this.$emit("selectedCell");
    },
    handleChange (e) {
      // console.log(e.target.checked);
      this.$emit('change', e.target.checked, this.index, this.listData);
    }
  },
};
</script>

<style lang="less" scoped>
/*重寫組件私有樣式*/
.navi-list-bg {
  padding: 2px 0;
  width: 100%;
  .content {
    cursor: pointer;
    height: 40px;
    background: #444;
    color: #fff;
    padding: 2px 0 2px 0px;
    border: 2px solid #444;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    width: 100%;
    .type {
      padding: 4px;
      background: #009aa3;
      width: 24px;
      text-align: center;
    }
    .list-name {
      width: 100px;
      padding-left: 5px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .ant-dropdown-trigger {
      background: #444;
      color: #fff;
      border-color: #444;
      box-shadow: none;
    }
  }
  .selected {
    border: 2px solid #1890ff;
  }
}
</style>